exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-hd[data-v-077867ff]{font-size:3rem}.wrap-content[data-v-077867ff]{display:flex;flex:1;white-space:nowrap;overflow:hidden}.wrap-content .inner-content[data-v-077867ff]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
